module.exports = __webpack_public_path__ + "engineering-culture.fysxmg5M.svg";